const BasePrefix = "CHILLNN";

export const CsvFileNamePrefixes = {
	reservation: BasePrefix + "_予約情報",
};

export type CsvFileNamePrefixKey = (typeof CsvFileNamePrefixes)[keyof typeof CsvFileNamePrefixes];
